
export const getAuth = state => state.auth;



/** WEBPACK FOOTER **
 ** ./src/members/state/auth/selectors.js
 **/